import { render, staticRenderFns } from "./CancellationHistory.vue?vue&type=template&id=4184b288&scoped=true&"
import script from "./CancellationHistory.vue?vue&type=script&lang=js&"
export * from "./CancellationHistory.vue?vue&type=script&lang=js&"
import style0 from "./CancellationHistory.vue?vue&type=style&index=0&id=4184b288&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184b288",
  null
  
)

export default component.exports